import KickImage from 'Reuseables/KickImage';
import { Button, Col } from 'reactstrap';
import styled from 'styled-components';

import AuthenticIconNoBG from '../../../images/authenticIconNoBG.png';
import SingleThumbnail from '../../PageProductDetails/Detail/Thumbnails/SingleThumbnail';

const LeftSideCheckout = props => {
  const { dataProduct, dataSell } = props;
  const noImage = !(dataProduct!==null && dataProduct.product_variant_images.length > 0);
  return(
    <div className="thumbnail-container">
      <SingleThumbnail
        noImage={noImage}
        src={!noImage? (dataProduct.product_variant_images[0].signed_url || dataProduct.product_variant_images[0].URL): null} 
        alt={!noImage? dataProduct.display_name: "Product's Image."}
      />
      <div className="text-wrapper">
        <span>{dataProduct.display_name}</span>
      </div>
      <div className="text-wrapper sku">
        <span>SKU: {dataProduct.SKU}</span>
      </div>
      <Col className="button-wrapper">
        <ButtonWrapper>
          <Button className="btn btn-grey" color="secondary">{dataSell.sneakers_condition}</Button>
        </ButtonWrapper>
      </Col>
      <Col className="button-wrapper">
        <ButtonWrapper>
          <Button className="btn btn-grey" color="secondary">US {dataSell.size.US}</Button>
        </ButtonWrapper>
      </Col>
      <Col className="authentic-icon">
        <KickImage src={AuthenticIconNoBG} alt="authenticIconNoBG.png"/>
        <span> Authentic. Guaranteed.</span>
      </Col>
    </div>
  )
}

const ButtonWrapper = styled.div`
    display: inline-block; 
    margin-right: 10px;
    margin-top: 10px;
    width: 120px
`

export default LeftSideCheckout;